<template>
    <div>
        RFIs
    </div>
</template>

<script>
    export default {
        name: "RFIs"
    }
</script>

<style scoped>

</style>